// src/helpers/withRouter.js
import { useNavigate, useLocation } from 'react-router-dom'

export function WithRouter(Component) {
  return function Wrapper(props) {
    const navigate = useNavigate()
    const location = useLocation()
    return <Component {...props} navigate={navigate} location={location} />
  }
}
